var _clipPath, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUk = function SvgUk(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 18,
    viewBox: "0 0 60 30"
  }, props), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "uk_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30 15h30v15zv15H0zH0V0zV0h30z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#00247d",
    d: "M0 0v30h60V0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 6,
    d: "m0 0 60 30m0-30L0 30"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#cf142b",
    strokeWidth: 4,
    d: "m0 0 60 30m0-30L0 30",
    clipPath: "url(#uk_svg__a)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 10,
    d: "M30 0v30M0 15h60"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#cf142b",
    strokeWidth: 6,
    d: "M30 0v30M0 15h60"
  })));
};
export { SvgUk as ReactComponent };
export default __webpack_public_path__ + "21b245e27330130d472ac7250aea3b0f.svg";